import { h, render } from 'preact';
import 'helpers/sentry';
import { publish, AGENT_LOADED } from 'helpers/pubsub';
import { clearFavouritesStore, clearInspirationsStore } from 'list/helpers/store';
import { initializeOptimizely } from 'helpers/optimizely';
import { country, language } from 'utils/settings';
import AgentModal from 'list/components/AgentModal';
import InspirationsRemovedModal from 'list/components/InspirationsRemovedModal';
import initFavourites from 'list/init';
import initDualCurrency from 'dual-currency/init';

export async function init() {
    if (window.ikea) {
        initFavourites();
        initDualCurrency();
    }
    /**
     *  When a user leaves certain pages we need to clear the store, since it likely contains outdated information.
     * Example pages:
     *  - the login page, where another account might now be used
     */
    const clearStorePaths = [`/${country}/${language}/profile`, `/${country}/${language}/login`];
    if (clearStorePaths.some(path => window.location.pathname.includes(path))) {
        window.addEventListener('beforeunload', function () {
            clearInspirationsStore();
            clearFavouritesStore();
        });
    }
    initializeOptimizely();
    publish(AGENT_LOADED, null);
}

init()
    .then(() => {
        render(
            <div>
                <AgentModal />
                <InspirationsRemovedModal />
            </div>,
            document.getElementById('list-agent')!
        );
    })
    .catch(() => {});
